module.exports = "/lucky-balls/img/weager/Repeat.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Repeat.png
// module id = 1170
// module chunks = 0